import * as React from 'react';

import { auth } from '../../firebase';
import { productInfoEndpoint } from '../../constants/api-endpoints';
import UpdateCategories from './UpdateCategories'; 

import styles from './UpdateProductInfo.module.css';

import PropTypes from 'prop-types';

/**
 * This component updates a product's category
 * 
 * Requires: Dispensary User Id  
 * 
 * @param {string} dispensaryId - the dispensary Id 
 * @param {function} onUpdate - the callback to run after update
 */

const UpdateProductInfo = ({ dispensaryId, onUpdate}) => {
   
  const [prodId, setProdId] = React.useState();
  const [name, setName] = React.useState();
  const [category, setCategory] = React.useState();
  const [description, setDescription] = React.useState();
  const [costUsaCents, setCostUsaCents] = React.useState();
  
  const [updateMsg, setUpdateMsg] = React.useState();
  
  const controller = new AbortController();

  const updateProduct = async (event) => {
   event.preventDefault();

    if (auth.currentUser) {
      auth.currentUser.getIdToken(false).then(function(idToken) {
        
        // image_url is also an available field
        const payload = {};
        if (name) { payload['name'] = name }
        if (description) { payload['description'] = description }
        if (category) { payload['category_name'] = category }
        if (costUsaCents) { payload['cost_usa_cents'] = costUsaCents }
        
        const updateProductUrl = productInfoEndpoint.replace(/\[dispId\]/, dispensaryId).replace(/\[prodId\]/, prodId); 

        setUpdateMsg('updating...');

        fetch(updateProductUrl, {
          method: 'PATCH',
          headers: {
            'Authorization': idToken,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload),
          signal: controller.signal
        }).then(response => {
          if (response.status === 204) {
            setUpdateMsg(`Product ${prodId}: updated!`);
            if(onUpdate) {
              // e.g. refresh the parent page
              // This is not actually triggering a refresh atm
              onUpdate();
            }
          } else {
            response.json().then(body => {
              setUpdateMsg(`${prodId}: ${body.error}`);
            });
        }}).catch(error => {
          setUpdateMsg(`${prodId}: ${error.message}`);
        });
      });
    }
    return false; // form
  };

  const onInputChange = (e) => {
    if (e.target.id === 'productId') { 
      setProdId(e.target.value);
    } else if (e.target.id === 'name') {
      setName(e.target.value);
    } else if (e.target.id === 'costUsaCents') {
      setCostUsaCents(e.target.value);     
    } else if (e.target.id === 'description') {
      setDescription(e.target.value);  
    } else if (e.target.id === 'category') {
      setCategory(e.target.value);  
    } 
  } 

  return ( 
    <>
      <form className={styles.updateForm}>
        <fieldset className={styles.fldSet}>
          <label htmlFor="productId">Product Id</label>
          <input id="productId" type="text" value={prodId} onChange={onInputChange}></input> 
        </fieldset>
  
        <fieldset className={styles.fldSet}>
          <label htmlFor="name">Name</label>
          <input id="name" type="text" value={name} onChange={onInputChange}></input> 
        </fieldset>
    
        <fieldset className={styles.fldSet}>
          <select id="category" value={category} onChange={onInputChange}>
            <option>Select Product Category</option>
            <option value="accessories">Accessories</option>
            <option value="concentrates">Concentrates</option>
            <option value="edibles">Edibles</option>
            <option value="flower">Flower</option>
            <option value="prerolls">PreRolls</option> 
            <option value="tinctures">Tinctures</option>
            <option value="topicals">Topicals</option>
            <option value="vaporizers">Vaporizers</option>
          </select>
        </fieldset>  
  
        <fieldset className={styles.fldSet}>
          <label htmlFor="costUsaCents">Cost Usa Cents</label>
          <input id="costUsaCents" type="text" value={costUsaCents} onChange={onInputChange}></input> 
        </fieldset>
  
        <fieldset className={styles.fldSet}>
          <button onClick={updateProduct}>Update Product</button>
        </fieldset>
  
        <fieldset className={`${styles.fldSet} ${styles.fullWidth}`}>
          <label htmlFor="description">Description</label>
          <input id="description" type="text" value={description} onChange={onInputChange}></input> 
        </fieldset>
  
        { updateMsg &&
          <div>{updateMsg}</div> 
        }
      </form>
      <div className={styles.categorySection}>
        <UpdateCategories />
      </div>
    </>
  )
}

UpdateProductInfo.propTypes = {
  dispensaryId: PropTypes.string.isRequired,
  onUpdate: PropTypes.func
};

export default UpdateProductInfo;